import { render, staticRenderFns } from "./CorrectivasDetalleGrid.vue?vue&type=template&id=7e2fd575&"
import script from "./CorrectivasDetalleGrid.vue?vue&type=script&lang=ts&"
export * from "./CorrectivasDetalleGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7e2fd575', component.options)
    } else {
      api.reload('7e2fd575', component.options)
    }
    module.hot.accept("./CorrectivasDetalleGrid.vue?vue&type=template&id=7e2fd575&", function () {
      api.rerender('7e2fd575', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/DetalleVehiculo/CorrectivasDetalleGrid.vue"
export default component.exports